/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireGradimento {
    position: number;
    question: string;
    answers: string[];
  }
  
  export const Q_GRADIMENTO: QuestionnaireGradimento[] = [
    {
      // tslint:disable-next-line:max-line-length
      position: 1, question: 'IBD Tool è semplice e intuitivo da utilizzare' ,
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 2, question: 'Penso che IBD Tool abbia migliorato la qualità del servizio fornito dall’Ospedale Mauriziano di Torino',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 3, question: 'Penso di aver ricevuto un servizio migliore grazie ad IBD Tool',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 4, question: 'Grazie ad IBD Tool mi sono sentito/a maggiormente seguito/a durante il periodo tra una visita ed un’altra',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 5, question: 'Continuerò ad utilizzare IBD Tool in futuro',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 6, question: 'Sono soddisfatto/a della qualità del servizio fornita da IBD Tool',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 7, question: 'IBD Tool ha reso più rapide le comunicazioni con i medici dell’Ospedale Mauriziano di Torino',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 8, question: 'Penso che IBD Tool mi permetta di recarmi in ospedale solo quando strettamente necessario',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 9, question: 'Ho avuto bisogno di assistenza per utilizzare IBD Tool',
      answers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ]
    },
    {
      position: 10, question: 'Suggerimenti:',
      answers: null
    },
  ];
  
  /* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */
  
  export class GradimentoResults {
    patientSSN: string;
    suggerimenti: string;
    results: number[];
      
    constructor(patientSSN: string,suggerimenti: string, results: number[]) {
      this.patientSSN = patientSSN;
      this.suggerimenti = suggerimenti;
      this.results = results;
    }
  
  }
  